import { accountsRoutes } from './accounts';
import { commonRoutes } from './common';
import { crmRoutes } from './crm';
import { fleetRoutes } from './fleet';
import { orderRoutes } from './order';
import { walletRoutes } from './wallet';
import { settingsRoutes } from './settings';
import { authRoutes } from './auth';
import { billingRoutes } from './billing';
import { financingRoutes } from './financing';

/**
 * Single source of truth for all app routes.
 *
 * Merge domain-specific route objects into one flat config.
 * Route names follow the `module_action` convention (e.g. order_new, wallet).
 */
export const appRoutes = {
  ...commonRoutes,
  ...orderRoutes,
  ...walletRoutes,
  ...accountsRoutes,
  ...settingsRoutes,
  ...fleetRoutes,
  ...crmRoutes,
  ...authRoutes,
  ...billingRoutes,
  ...financingRoutes,
} as const;

/** Union of all route names */
export type RouteName = keyof typeof appRoutes;

/**
 * Extracts the param type for a given route name.
 * Returns `undefined` when the route has no params.
 */
export type RouteParamsFor<T extends RouteName> = (typeof appRoutes)[T] extends { params: infer P }
  ? P
  : undefined;
